<template>
  <div
    v-if="hasIncentivisedProposition"
    class="py-3 px-5 md:px-6 rounded border-2 border-racq-white shadow-md w-full my-8 md:my-6"
    :aria-expanded="expanded"
    role="button"
    tabindex="0"
    @click="toggleExpand"
    @keydown.enter="toggleExpand"
    @keydown.space.prevent="toggleExpand"
  >
    <div class="flex flex-col gap-2.5 px-6 pb-5 pt-3 basis-full rounded-md border-solid border-2 border-racq-white">
      <div class="flex gap-4 rounded">
        <div class="flex flex-col justify-center basis-9 shrink-0">
          <img :src="getFilterStep().imageUrl" Width="40" Height="30" alt="offer image" class="max-w-none h-7" />
        </div>
        <div :class="expanded ? 'text-racq-blue font-bold text-base-bold pt-1.5' : 'text-base-bold pt-1.5'">
          <RichText :field="{ value: getFilterStep().headerText }" />
        </div>
        <div class="flex flex-col justify-center ml-auto payment-confirmation__proposition-expander">
          <ShowHideButton :showMore="expanded" :hideLabel="true" appendClass="!mt-0" @click="toggleExpand" />
        </div>
      </div>
      <div :class="expanded ? 'text-racq-blue font-bold text-base-bold my-2 md:my-0' : 'text-base-bold my-2 md:my-0'">
        <RichText :field="{ value: filterStep?.headerText || '' }" />
      </div>
      <div class="flex flex-col justify-center ml-auto">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
          :class="expanded ? 'scale-y-[-1]' : 'scale-y-100'"
          class="transition-transform duration-200"
        >
          <path d="M1 4L8 11L15 4" stroke="#0864BC" stroke-width="2" />
        </svg>
      </div>
    </div>
    <div v-if="expanded" class="mt-2.5">
      <RichText class="text-base" :field="{ value: filterStep?.messageText || '' }" />
    </div>
  </div>
</template>

<script lang="ts" setup>
import { ref, computed } from 'vue';
import {
  IDecisionIntelligenceOfferResponse,
  IProposition,
  IStep,
} from '@/interfaces/decision-intelligence/decision-intelligence-response';
import { RichText } from '@sitecore-jss/sitecore-jss-vue';
import ShowHideButton from '../ShowHideButton/ShowHideButton.vue';
// Define props and emitters
// ------------------------------------------------------------- //
const props = defineProps<{
  decisionOffer?: IDecisionIntelligenceOfferResponse;
  stepTitle?: string;
  isRenewal?: boolean;
  isQuote?: boolean;
  isCrossSell: boolean;
  expandedByDefault: boolean;
}>();

// Reactive state
const expanded = ref(props.expandedByDefault);

// Computed properties
const hasIncentivisedProposition = computed(() => props.decisionOffer?.propositions?.some((x) => x.incentivised));

const journeyType = computed(() => {
  if (props.isRenewal) return 'Make a payment';
  if (props.isQuote) return 'Quote';
  return 'Purchase';
});

const filterStep = computed<IStep | null>(() => {
  const proposition = props.decisionOffer?.propositions?.find((x) => x.incentivised);
  return (
    proposition?.displaySteps?.find(
      (x) => x.stepName === props.stepTitle && x.journey === journeyType.value && x.isCrossSell === props.isCrossSell
    ) || null
  );
});

// Methods
const toggleExpand = () => {
  expanded.value = !expanded.value;
};

const getFilterStep = (): IStep => {
  const proposition = props.decisionOffer?.propositions?.filter((x) => x.incentivised)[0];
  return (
    proposition?.displaySteps?.filter(
      (x) =>
        x.stepName == props.stepTitle &&
        x.journey == (props.isRenewal ? 'Make a payment' : props.isQuote ? 'Quote' : 'Purchase') &&
        x.isCrossSell == props.isCrossSell
    )[0] ?? ({} as IStep)
  );
};
</script>
